var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_laptop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_laptop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Macbook-Pro_762901",
    transform: "translate(10.000000, 17.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7806378,0 C38.269978,0 38.6666667,0.395622991 38.6666667,0.895673795 L38.6666667,0.895673795 L38.6666667,23.6607143 L40,23.6607143 L40,24.3303571 C40,24.7001907 39.7010279,25 39.3308276,25 L39.3308276,25 L0.66917236,25 C0.299598671,25 0,24.7027691 0,24.3303571 L0,24.3303571 L0,23.6607143 L1.33333333,23.6607143 L1.33333333,0.895673795 C1.33333333,0.40100683 1.7273438,0 2.21936218,0 L2.21936218,0 Z M37.7777778,1.33928571 L2.22222222,1.33928571 L2.22222222,23.6607143 L16.8888889,23.6607143 L17.0594615,24.1176052 C17.1482448,24.3554175 17.4300104,24.5535714 17.6863302,24.5535714 L22.3136698,24.5535714 C22.5667773,24.5535714 22.8506482,24.3583827 22.9405385,24.1176052 L23.1111111,23.6607143 L37.7777778,23.6607143 L37.7777778,1.33928571 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLaptop);
export default __webpack_public_path__ + "static/media/icon_laptop.f3c02ba1e88548f03afc90c5f1d19195.svg";
export { ForwardRef as ReactComponent };